import call from "./call";

export const getVapidPublicKey = async (): Promise<string> => {
  const response = await call.get<{ public_key: string }>(
    "/v1/push/public_key/"
  );
  return response.data.public_key;
};

export const savePushSubscription = async (
  subscription: PushSubscriptionJSON
): Promise<void> => {
  await call.post("/v1/push/subscribe/", { subscription });
};

export const getPushSubscriptionStatus = async (
  endpoint: string
): Promise<boolean> => {
  const response = await call.post<{ subscribed: boolean }>(
    "/v1/push/status/",
    { endpoint }
  );
  return response.data.subscribed;
};

export const removePushSubscription = async (
  endpoint: string
): Promise<void> => {
  await call.post("/v1/push/unsubscribe/", { endpoint });
};
